<div class="panel__header">
        <span class="panel__header__title" style="font-size: 20px;">
                Asset Summary
        </span>
      </div>
<div class="panel__sub-header panel__content no-padding"  style="margin-top: 2px;    max-width: 95%;">
    
    <div class="column-container flex-grow">
        <div class="column-container__column">
            <!-- <img *ngIf="system.SystemType == 'Chain'" class="chain-photo" src="/Content/Images/chain.jpg" alt="Chain" /> -->
            <!-- <img *ngIf="system.SystemType == 'Frame'" class="chain-photo" src="/Content/Images/frame.jpg" alt="Chain" /> -->
           
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__important" style="font-size: 18px; font-weight: 500;">
                 {{Implemetdetails.Name}}
                </span>
                <span *ngIf="Implemetdetails.CopyFromId > 0" class="text-block__important" style="font-size: 18px; font-weight: 500;">
                    <a routerLink="/implementdetails/{{Implemetdetails.CopyFromId}}">
             {{Implemetdetails.TemplateSrNo}} </a>
            </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label">
                    Worn - Critical
                </span>
                <span class="text-block__important {{getEvalClass(Implemetdetails.CrirticalWorstWorn)}}" >
                 {{Implemetdetails.CrirticalWorstWorn}}%
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label">
                     Worn - Normal
                </span>
                <span class="text-block__important {{getEvalClass(Implemetdetails.WorstNormalWorn)}}" >
                 {{Implemetdetails.WorstNormalWorn}}%
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label" style="text-align: center;">
                   GET
                </span>
                <span class="text-block__important {{getEvalClass(Implemetdetails.GETWorstWorn)}}" >
                 {{Implemetdetails.GETWorstWorn}}%
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label">
                 #Crack/Length
                </span>
                <span class="text-block__important">
                  {{Implemetdetails.TotalCracks}}/{{Implemetdetails.TotalCrackLength}}
                </span>
                <!-- <span class="text-block__important {{getEvalClass(Implemetdetails.WorstCrackWorn)}}" style="    margin-left: 53px;
                margin-top: -20px;" >
                    {{Implemetdetails.WorstCrackWorn}}%
                   </span> -->
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label">
                    Worn - Crack
                </span>
                <span class="text-block__important {{getEvalClass(Implemetdetails.WorstCrackWorn)}}" >
                 {{Implemetdetails.WorstCrackWorn}}%
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label">
                Life
                </span>
                <span class="text-block__important">
              {{ Implemetdetails.Life | number: '1.'}}
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label">
                  Residual 100%
                </span>
                <span class="text-block__important">
                 {{Implemetdetails.Residual| number: '1.'}}
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label">
                  Residual 120%
                </span>
                <span class="text-block__important">
                 {{Implemetdetails.Residual120?.toFixed(0) | number: '1.'}}
                </span>
            </div>
        </div>
        <!-- <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label">
                  Purchase Cost
                </span>
                <span class="text-block__important">
                 $ {{Implemetdetails.PurchaseCost}}
                </span>
            </div>
        </div> -->
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label">
                   Cycle Cost
                </span>
                <span class="text-block__important">
                 $ {{Implemetdetails.CurrentCycleCost | number: '1.'}}
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label">
                   Overall Cost
                </span>
                <span class="text-block__important">
                    $ {{Implemetdetails.OverviewTotal | number: '1.'}}
                </span>
            </div>
        </div>

        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label" style="max-width: 100px;">
                  Unscheduled GET Service Hrs
                </span>
                <span class="text-block__important" >
                     {{Implemetdetails.TotalServiceHours | number: '1.'}}
                </span>
            </div>
        </div>

        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label" style="max-width: 100px;">
                  Replacement Date (100%)
                </span>
                <span class="text-block__important" [ngClass]="{'yellow' : Implemetdetails.RemovelDateTitle != ''}"
                 [title]="Implemetdetails.RemovelDateTitle" >
                     {{Implemetdetails.RemovelDate}}
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label" style="max-width: 100px; ">
                  Replacement Date (120%)
                </span>
                <span class="text-block__important" >
                     {{Implemetdetails.RemovelDate120}}
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label" style="max-width: 100px;">
                  Build #
                </span>
                <span class="text-block__important" >
                     {{Implemetdetails.BuildNo}}
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label" style="max-width: 100px;">
                 Implement Type
                </span>
                <span class="text-block__important" >
                     {{Implemetdetails.ImplementTypeName}}
                </span>
            </div>
        </div>
        <div class="column-container__column">
            <div class="text-block">
                <span class="text-block__label" style="max-width: 100px;">
                 Install Date
                </span>
                <span class="text-block__important" >
                     {{Implemetdetails.BucketInstall}}
                </span>
            </div>
        </div>
      <div class="column-container__column" title="Re-Calculate Implement and Components Life" style="cursor: pointer;">
        <a *ngIf="!reCalLife" (click)="recalculateImplementAndComponentsLife()">
          <i class="material-icons button__icon" style="font-size: 30px !important;">refresh</i>
        </a>
        <span *ngIf="reCalLife" style="font-size: 25px;" title="Processing...">...</span>
        </div>
    </div>
</div>
